<template>
  <div class="link-input-container" :class="[readonly && 'readonly', !isValidUrl && 'mb-4']">
    <feather-icon icon="LinkIcon" />
    <div class="line"></div>
    <input v-if="editType" ref="linkInput" type="text" :readonly="readonly" :placeholder="placeholder" v-model="inputValue" @blur="inputBlur" />
    <a v-else :href="isValidUrl ? inputValue : null" target="_blank">{{ inputValue | removeProtocol }}</a>
    <div v-if="!editType && !readonly" @click="editLink" class="edit-btn">수정</div>
    <p v-if="!isValidUrl" style="position: absolute; bottom: -18px; color: #ea5455; font-size: 11px">URL형식이 아닙니다.</p>
  </div>
</template>
<script>
export default {
  props: {
    value: String,
    placeholder: String,
    readonly: Boolean,
  },
  filters: {
    removeProtocol(value) {
      if (!value) return "";
      return value.replace(/^(http:\/\/|https:\/\/)/, "");
    },
  },
  computed: {
    isValidUrl() {
      if (!this.inputValue) return true;
      const pattern = new RegExp(
        "^(https?:\\/\\/)?" + // 프로토콜
          "((([a-zA-Z\\d\\uac00-\\ud7af]([a-zA-Z\\d\\uac00-\\ud7af-]*[a-zA-Z\\d\\uac00-\\ud7af])*)\\.)+[a-zA-Z\\d\\uac00-\\ud7af]{2,}|" + // 도메인 이름
          "((\\d{1,3}\\.){3}\\d{1,3})|" + // 또는 IP 주소 (IPv4)
          "([\\w-]+\\.)*[\\w-]+\\.[\\w-]{2,})" + // 또는 한글 도메인 이름
          "(\\:\\d+)?(\\/[-a-zA-Z\\d%_.~+\\u00a1-\\uffff\\uac00-\\ud7af]*)*" + // 포트 및 경로
          "(\\?[;&a-zA-Z\\d%_.~+=-]*)?" + // 쿼리 문자열
          "(\\#[-a-zA-Z\\d_]*)?$",
        "i"
      ); // 프래그먼트 로케이터

      return !!pattern.test(this.inputValue);
    },
  },
  watch: {
    value: {
      handler(value) {
        this.inputValue = value;
      },
    },
  },
  data() {
    return {
      editType: !!this.value,
      inputValue: this.value,
    };
  },
  methods: {
    inputBlur() {
      if (!!this.inputValue && !this.inputValue.includes("http://") && !this.inputValue.includes("https://")) this.inputValue = "https://" + this.inputValue;
      this.editType = !this.inputValue;
      this.$emit("input", this.inputValue);
    },
    editLink() {
      this.editType = true;
      this.$nextTick(() => {
        this.$refs.linkInput.focus();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-input-container {
  position: relative;

  display: flex;
  align-items: center;

  flex: 1;
  width: 100%;
  font-size: 1rem !important;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  box-sizing: border-box;
  box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);

  outline: none;
  text-transform: none;
  text-decoration: none;

  transition: all 0.3s ease;

  &.readonly {
    background-color: #fafafa;
  }

  &:focus-within {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgb(0 0 0 / 15%);
  }

  .feather-icon {
    width: 20px;
    height: 20px;
    padding: 10px;
    box-sizing: content-box;
  }
  .line {
    width: 1px;
    height: 26px;
    background: #cdcdcd;
    margin: 6px 0;
  }
  input {
    flex: 1;
    background: none;
    border: none;
    padding: 6px 10px !important;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  a {
    text-decoration: underline;
    padding: 6px 10px !important;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .edit-btn {
    min-width: 50px;
    text-align: center;
    color: #7e72f2;
    padding: 0 10px !important;
    margin-left: auto;
    cursor: pointer;
  }
}
</style>
